/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Doc_Upload_Duplicate_FileInputs */

const en_doc_upload_duplicate_file = /** @type {(inputs: Doc_Upload_Duplicate_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} was already added to this case.`)
};

const pt_br2_doc_upload_duplicate_file = /** @type {(inputs: Doc_Upload_Duplicate_FileInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} já foi adicionado a este caso.`)
};

/**
* | output |
* | --- |
* | "{name} was already added to this case." |
*
* @param {Doc_Upload_Duplicate_FileInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_upload_duplicate_file = /** @type {((inputs: Doc_Upload_Duplicate_FileInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Upload_Duplicate_FileInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_upload_duplicate_file(inputs)
	return pt_br2_doc_upload_duplicate_file(inputs)
});